import 'css-chunksrc/client/scenes/resourceEdition/infoResource/styles.scss';export default {
  "dataUser": "_dataUser_ml6r6_1",
  "profession": "_profession_ml6r6_9",
  "avatar": "_avatar_ml6r6_15",
  "name": "_name_ml6r6_25",
  "email": "_email_ml6r6_31"
};